// extracted by mini-css-extract-plugin
export default {"alertContainer":"DeleteTagModal__alertContainer___CEDeO","buttonContianer":"DeleteTagModal__buttonContianer___xkWJ8"};